/* ==========================================================================
   VT FESTIVE POPUP
   Shows one campaign popup after a delay, remembers that the visitor closed
   it, and never touches any other element on the page.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'vt_fp_seen_';

  function store() {
    try {
      var t = '__vt_fp_test__';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  function Popup(root) {
    this.root = root;
    this.id = root.dataset.campaignId || 'default';
    this.delay = parseInt(root.dataset.delay, 10) || 0;
    this.mode = root.dataset.frequency || 'session';
    this.days = parseInt(root.dataset.days, 10) || 7;
    this.ls = store();
    this.timer = null;
    this.lastFocus = null;

    if (!this.allowed()) return;
    if (this.alreadySeen()) return;

    this.bind();
    this.schedule();
  }

  Popup.prototype.allowed = function () {
    var w = window.innerWidth;
    if (w <= 749 && this.root.dataset.mobile !== 'true') return false;
    if (w > 749 && this.root.dataset.desktop !== 'true') return false;
    return true;
  };

  Popup.prototype.storeKey = function () {
    return KEY + this.id;
  };

  Popup.prototype.alreadySeen = function () {
    if (this.mode === 'always') return false;

    if (this.mode === 'session') {
      try {
        return window.sessionStorage.getItem(this.storeKey()) === '1';
      } catch (e) {
        return false;
      }
    }

    if (!this.ls) return false;
    var until = parseInt(this.ls.getItem(this.storeKey()), 10);
    if (!until) return false;
    return Date.now() < until;
  };

  Popup.prototype.remember = function () {
    if (this.mode === 'always') return;

    if (this.mode === 'session') {
      try { window.sessionStorage.setItem(this.storeKey(), '1'); } catch (e) {}
      return;
    }

    if (!this.ls) return;
    var until = Date.now() + (this.days * 24 * 60 * 60 * 1000);
    try { this.ls.setItem(this.storeKey(), String(until)); } catch (e) {}
  };

  Popup.prototype.schedule = function () {
    var self = this;
    this.timer = setTimeout(function () { self.open(); }, this.delay);
  };

  Popup.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = this.root.querySelector('[data-vt-fp-close]');
    if (close) close.focus();
    document.dispatchEvent(new CustomEvent('vt:festive-popup:open', { detail: { id: this.id } }));
  };

  Popup.prototype.close = function () {
    clearTimeout(this.timer);
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    this.remember();
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Popup.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      if (e.target === self.root && self.root.dataset.closeOnOverlay === 'true') {
        self.close();
        return;
      }
      var c = e.target.closest ? e.target.closest('[data-vt-fp-close]') : null;
      if (c) { e.preventDefault(); self.close(); }
    });

    // A click on the campaign link counts as seen, so it does not reappear
    var links = this.root.querySelectorAll('[data-vt-fp-go]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () { self.remember(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.root.classList.contains('is-open')) self.close();
    });
  };

  function init() {
    var roots = document.querySelectorAll('[data-vt-fp-root]:not([data-vt-fp-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-vt-fp-ready', 'true');
      try {
        new Popup(roots[i]);
      } catch (e) {
        if (window.console && console.warn) console.warn('[vt-festive-popup]', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // In the theme editor, show it immediately on every reload so it can be styled
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-vt-fp-root]');
    if (!root) return;
    root.removeAttribute('data-vt-fp-ready');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    init();
  });

  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-vt-fp-root]');
    if (root) root.classList.add('is-open');
  });
})();